
import { defineComponent } from "vue";
import ButtonVue from "../ui/Button.vue";

export default defineComponent({
  components: {
    appButton: ButtonVue,
  },
});
